import { READING_ACTION_TYPES, SET_ROUND_SESSION_ID } from '../actions/action_types';

export const initialState = {
  bookId: '',
  columnsNumber: 2,
  title: '',
  titleChapterId: '',
  currentChapterId: '',
  chapters: [],
  currentPage: 0,
  layout: {},
  pages: {},
  loaded: false,
  readerReady: false,
  attempts: 1,
  status: '',
  roundSessionId: undefined,
  isPaginationLocked: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case READING_ACTION_TYPES.SET_BOOK:
      return { ...state, bookId: payload.bookId || '' };
    case READING_ACTION_TYPES.SET_BOOK_STATE:
      return {
        ...state,
        titleChapterId: payload.titleChapterId || '',
        currentChapterId: payload.currentChapterId || '',
        status: payload.status || '',
        currentPage: payload.currentPage || 0,
        attempts: payload.attempts || 1,
        roundSessionId: payload.roundSessionId,
      };
    case READING_ACTION_TYPES.SET_STATUS:
      return { ...state, status: payload.status || '' };
    case SET_ROUND_SESSION_ID:
      return { ...state, roundSessionId: payload };
    case READING_ACTION_TYPES.LOCK_PAGINATION:
      return { ...state, isPaginationLocked: payload.isPaginationLocked };
    case READING_ACTION_TYPES.OPEN_BOOK: {
      const {
        pageInfo: { isFixedLayout, pagination, canGoRight },
      } = payload;
      const { spreadCount } = pagination;
      return {
        ...state,
        title: payload.title || '',
        titleChapterId: payload.titleChapterId || '',
        chapters: payload.chapters || [],
        currentChapterId: payload.currentChapterId || '',
        columnsNumber: payload.columnsNumber || 2,
        layout: { isFixedLayout, spreadCount },
        pages: { canGoLeft: true, canGoRight },
        loaded: payload.ready,
      };
    }
    case READING_ACTION_TYPES.SET_READER_READY:
      return { ...state, readerReady: payload.ready };
    case READING_ACTION_TYPES.UPDATE_PAGINATION_STATUS: {
      const { canGoLeft, canGoRight } = payload;
      return {
        ...state,
        pages: { canGoLeft, canGoRight },
      };
    }
    case READING_ACTION_TYPES.UPDATE_PAGINATION: {
      const {
        pageInfo: { idref, isFixedLayout, pagination, canGoRight },
      } = payload;
      const { currentPageIndex, spreadCount } = pagination;
      return {
        ...state,
        currentChapterId: idref || '',
        currentPage: currentPageIndex,
        pages: { canGoLeft: true, canGoRight },
        layout: { isFixedLayout, spreadCount },
        isPaginationLocked: false,
      };
    }
    case READING_ACTION_TYPES.TRY_AGAIN:
      return { ...state, attempts: payload.attempts };
    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;
    default:
      return state;
  }
};
